import AddIcon from "@mui/icons-material/AddRounded";
import { Button, Popover } from "@mui/material";
import { useState } from "react";
import AddFilterSelector from "./AddFilterSelector";
import { useFilterContext } from "./FilterContext";
import { addFilterAction } from "./filterState";

const AddFilterButton = () => {
  const { filterState, setFilterState } = useFilterContext();

  const [adding, setAdding] = useState(false);

  const [buttonEl, setButtonEl] = useState<HTMLButtonElement | null>(null);

  if (filterState.availableFilters.length === 0) {
    return null;
  }

  const handleFilterSelected = (filterId: string) => {
    setAdding(false);
    setFilterState(addFilterAction(filterId));
  };

  return (
    <>
      <Button variant="text" ref={(el) => setButtonEl(el)} onClick={() => setAdding(!adding)} startIcon={<AddIcon />}>
        Add Filter
      </Button>
      <Popover
        open={adding}
        onClose={() => setAdding(false)}
        anchorEl={buttonEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <AddFilterSelector onSelected={handleFilterSelected} />
      </Popover>
    </>
  );
};

export default AddFilterButton;
